import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { Badge } from '../ui/badge';
import './styles.css';

const findCategoryOption = (options, current) => {
  if (!current || !options?.length) return null;

  if (typeof current === 'object') {
    return (
      options.find(
        (option) =>
          (current.value && option.value === current.value) ||
          (current.id && option.id === current.id) ||
          (current.label && option.label === current.label)
      ) || null
    );
  }

  return (
    options.find(
      (option) =>
        option.label === current ||
        option.display_name === current ||
        option.value === current ||
        option.id === current
    ) || null
  );
};

const Categories = ({
  title,
  description,
  children,
  isEditing,
  onFieldChange,
  canEdit,
  categories,
  googleProfileInfo,
  additionalCategories = []
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const userChangedRef = useRef(false);

  // MinusIcon is used for empty fields
  const isMinusIcon =
    children.props?.className?.includes('fas fa-minus') ||
    (typeof children === 'string' && children === 'fas fa-minus');

  useEffect(() => {
    if (!isEditing) {
      userChangedRef.current = false;
    }

    if (!userChangedRef.current) {
      setSelectedOption(findCategoryOption(categories, googleProfileInfo));
    }
  }, [isEditing, categories, googleProfileInfo]);

  const handleCategoryChange = (option) => {
    userChangedRef.current = true;
    setSelectedOption(option);
    onFieldChange(option);
  };

  const selectStyles = {
    singleValue: (base) => ({
      ...base,
      display: 'flex',
      alignItems: 'center',
      fontSize: '0.875rem'
    })
  };

  return (
    <div className="space-y-2 min-w-0">
      <p className="text-sm sm:text-base font-semibold flex items-center gap-2 flex-wrap break-words">
        {title}
      </p>
      {description && (
        <p className="text-sm text-muted-foreground break-words">
          {description}
        </p>
      )}
      <div className="mt-2">
        {isEditing && canEdit && !isMinusIcon ? (
          <>
            <Select
              id="categories"
              options={categories}
              value={selectedOption}
              onChange={handleCategoryChange}
              styles={selectStyles}
            />
          </>
        ) : (
          <div>
            {isEditing && canEdit && isMinusIcon ? (
              <>
                <Select
                  id="categories"
                  options={categories}
                  value={selectedOption}
                  onChange={handleCategoryChange}
                  styles={selectStyles}
                />
              </>
            ) : (
              <>
                <div className="flex items-center gap-2 flex-wrap mt-2">
                  {/* Categoría principal - Badge azul (primary) */}
                  {googleProfileInfo && (
                    <Badge className="bg-primary text-primary-foreground">
                      {googleProfileInfo}
                    </Badge>
                  )}

                  {/* Categorías adicionales - Badge gris (secondary) */}
                  {additionalCategories && additionalCategories.length > 0 && (
                    <>
                      {additionalCategories.map((category, index) => (
                        <Badge key={index} variant="secondary">
                          {category.displayName}
                        </Badge>
                      ))}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Categories;
